import React from 'react';
import UseContext from '../../../hooks/useContext';
import SlideOverAddMission from './data/slideOverAddMission/slideOverAddMission';
import SlideOverAddCompany from './data/slideOverCompany/slideOverAddCompany';
import SlideOverCompany from './data/slideOverCompany/slideOverCompany';
import SlideOverQualification from './data/slideOverQualification/slideOverQualification';
import SlideOverSchedule from './data/slideOverSchedule/slideOverSchedule';
import SlideOverTempWorker from './data/slideOverTempWorker/SlideOverTempWorker';
import SlideOverMission from './data/slideOverMission/slideOverMission';
import SlideOverTimeSheetHistory from './data/slideOverTimeSheetHistory/slideOverTimeSheetHistory';

const dataSlideOver = new Map();
dataSlideOver.set('add_company', <SlideOverAddCompany />);
dataSlideOver.set('get_company', <SlideOverCompany />);
dataSlideOver.set('get_temp_worker', <SlideOverTempWorker />);
dataSlideOver.set('get_schedule', <SlideOverSchedule />);
dataSlideOver.set('qualification', <SlideOverQualification />);
dataSlideOver.set('add_mission', <SlideOverAddMission />);
dataSlideOver.set('get_mission', <SlideOverMission />);
dataSlideOver.set('get_timesheet_history', <SlideOverTimeSheetHistory />);

const DataSlideOver = ({ setShowCV }) => {
  const { slideOverType } = UseContext();
  const Component = dataSlideOver.get(slideOverType);
  
  // Passer setShowCV uniquement au SlideOverTempWorker
  if (slideOverType === 'get_temp_worker' && setShowCV) {
    return React.cloneElement(Component, { setShowCV });
  }
  
  return <>{Component}</>;
};

export default DataSlideOver;
